import React, { useState } from "react";
import InquiryToCustomer from "@/src/types/Entities/InquiryToCustomer";
import { Box, Divider, Typography } from "@mui/material";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import InquiryToCustomerMediaObjects from "./InquiryToCustomerMediaObjects";
import InquiryToCustomerDocument from "./InquiryToCustomerDocument";

type InquiryToCustomerDocumentsBoxProps = {
  inquiryToCustomer: InquiryToCustomer;
  product: AbstractCase;
  hideMediaObjects?: boolean;
  updateInquiryToCustomer: (data: Partial<InquiryToCustomer>) => Promise<InquiryToCustomer>;
};

export default function InquiryToCustomerDocumentsBox({
  inquiryToCustomer,
  product,
  hideMediaObjects = false,
  updateInquiryToCustomer,
}: InquiryToCustomerDocumentsBoxProps) {
  const [isFileUploading, setIsFileUploading] = useState(false);

  if (!inquiryToCustomer.requestedDocuments) {
    return null;
  }

  return (
    <Box>
      <Typography variant={"h7"} component={"h2"}>
        Benötigte Dokumente
      </Typography>
      {!!inquiryToCustomer.inquiryTextDocuments && (
        <>
          <Typography variant={"body2"} sx={{ marginTop: "1.5rem" }}>
            <strong>Wichtige Hinweise zu den benötigten Dokumenten:</strong>
          </Typography>
          <Typography variant={"body2"} sx={{ margin: "1rem 0 1.5rem" }} dangerouslySetInnerHTML={{ __html: inquiryToCustomer.inquiryTextDocuments }} />
        </>
      )}
      {!hideMediaObjects && <InquiryToCustomerMediaObjects inquiryToCustomer={inquiryToCustomer} />}
      {inquiryToCustomer.requestedDocuments.map((document, index) => {
        return (
          <Box key={"inquiryDocument" + index} sx={{ marginTop: "1rem" }}>
            <InquiryToCustomerDocument
              document={document}
              inquiryToCustomer={inquiryToCustomer}
              index={index}
              product={product}
              onHandleUploading={setIsFileUploading}
              isBlocked={isFileUploading}
              updateInquiryToCustomer={updateInquiryToCustomer}
            />
            {index + 1 !== inquiryToCustomer.requestedDocuments?.length && <Divider sx={{ margin: "1rem 0" }} />}
          </Box>
        );
      })}
      {!inquiryToCustomer.hideInquiryTextDocumentsCustomer && (
        <ValidatorTextField
          sx={{ marginTop: "1.5rem" }}
          label="Ihre Anmerkungen und Fragen (optional)"
          name="inquiryTextDocumentsCustomer"
          placeholder={"Sie haben Anmerkungen oder Fragen zu den angefragten Dokumenten, dann teilen Sie uns diese gerne kurz hier mit."}
          multiline
          rows={5}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    </Box>
  );
}
